import React from 'react';
import { Category } from '../../../types';
import styled from 'styled-components';
import { FormGroup, FormSelect, IconClear, ButtonIcon } from '@spotify-internal/encore-creator-web';

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledButtonIcon = styled(ButtonIcon)`
  margin-left: 16px;
`;

interface Props {
  categories: Category[];
  onSelectCategory(category: Category): void;
  onRemove?(): void;
  label: string;
  id: string;
  required?: boolean;
}

export function DefaultCategoryPicker(props: Props) {
  function handleSelectCategory(event: React.ChangeEvent<HTMLSelectElement>) {
    const category = {
      ...props.categories.find(cat => cat.value === event.target.value)!,
      subcategories: [],
    };

    props.onSelectCategory(category);
  }

  return (
    <FormGroup
      label={props.label}
      labelFor={props.id}
      indicator={props.required ? 'required' : undefined}
    >
      <InputContainer>
        <FormSelect
          data-testid="placeholder-category-select"
          onChange={handleSelectCategory}
          defaultValue=""
          id={props.id}
        >
          <option value="" disabled>
            Select category
          </option>
          {props.categories.map(category => (
            <option key={category.value} value={category.value}>
              {category.name}
            </option>
          ))}
        </FormSelect>
        {props.onRemove ? (
          <StyledButtonIcon onClick={props.onRemove} data-testid="remove-placeholder-category">
            <IconClear aria-label="IconClear" iconSize={24} />
          </StyledButtonIcon>
        ) : null}
      </InputContainer>
    </FormGroup>
  );
}
